import { gql, useQuery } from '@apollo/client';
import {
  getAvailableCounsellors,
  getAvailableCounsellorsVariables,
} from './__generated__/getAvailableCounsellors';

export const GET_COUNSELLORS = gql`
  query getAvailableCounsellors(
    $date: Date!
    $times: [String!]!
    $serviceId: ID!
    $emailAddress: String!
    $filters: BookingFilters!
  ) {
    availableCounsellors(
      input: {
        date: $date
        times: $times
        serviceId: $serviceId
        emailAddress: $emailAddress
        filters: $filters
      }
    ) {
      date
      timeZone
      counsellors {
        id
        firstName
        lastName
        bio
        picture
        bookingTimes {
          date
          timeSlots {
            from
            to
          }
        }
      }
    }
  }
`;

export const useGetCounsellors = (
  variables: getAvailableCounsellorsVariables,
  skip = false,
) => {
  const { data, loading, error } = useQuery<
    getAvailableCounsellors,
    getAvailableCounsellorsVariables
  >(GET_COUNSELLORS, {
    variables,
    errorPolicy: 'all',
    returnPartialData: false,
    skip,
  });

  return { data, loading, error };
};
